import {safeDecode} from "@/utils";

const SOLUTION_CUSTOM_MAP = [
    // {
    //     title: "R&BD",
    //     path: "R&BD",
    //     isCustom: true,
    // },
]
const WEARABLE_CUSTOM_MAP = [
    // {
    //     title: "center",
    //     path: "center",
    //     isCustom: true,
    // },
]






export const customData = (data, type) => {
    if (type === "solutions") {
        return [
            ...data,
            ...SOLUTION_CUSTOM_MAP,
        ];
    }

    if (type === "wearable") {
        return [
            ...data,
            ...WEARABLE_CUSTOM_MAP,
        ];
    }

    return data;
};

export const buildCateNav = (tree, segments = [], opt = {}) => {
    const depth = opt.depth ?? 0;
    const currentList = depth === 0 ? [] : (opt.currentList ?? []);
    const selects = depth === 0 ? [] : (opt.selects ?? []);
    const leaf = opt.leaf ?? null;
    if (!Array.isArray(tree) || tree.length === 0) {
        return { selects, leaf, currentList };
    }
    const wanted = safeDecode(segments[depth]);
    const picked = wanted ? tree.find((node) => node.path === wanted) : null;
    const node = picked || tree[0];
    // console.log(node)
    if (!node) {
        return { selects, leaf, currentList };
    }
    currentList[depth] = node;
    if (depth > 0) {
        selects.push({
            key: `select-${depth}`,
            value: node,
            options: tree.map((item) => ({
                label: item.title,
                value: item.path,
            })),
        });
    }
    if (node?.productId) {
        return { selects, leaf: node, currentList };
    }

    return buildCateNav(node.children || [], segments, {
        depth: depth + 1,
        currentList,
        selects,
        leaf,
    });
};

export const buildCateChange = (rootTree, currentSegments, depth, nextTitle) => {
    const base = Array.isArray(currentSegments) ? currentSegments.slice(0, depth) : [];
    base[depth] = nextTitle;
    const { currentList } = buildCateNav(rootTree, base);
    return currentList;
}



